import React from "react"
import styled from "styled-components"

const Standfirst = styled.p`
  font-size: 1.6rem;
  line-height: 1.25;
  margin-bottom: 2rem;

  @media print {
    margin-bottom: 2rem;
  }
`

interface IProps {
  children: React.ReactNode
}

const StandFirst = ({ children }: IProps) => {
  return <Standfirst>{children}</Standfirst>
}

export default StandFirst
